import styled from "styled-components";
import Logo from "../../utils/globalStyles/logo/logo-02.png";

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  padding: 32px; /* Garante o respiro nas laterais no mobile */
  box-sizing: border-box; /* Evita que o padding crie barras de rolagem (aquela linha branca) */

  @media (min-width: 768px) {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
`;

export const Image = styled.div`
  width: 140px;
  height: 140px;
  margin-bottom: 32px;
  border: none;
  background-image: url(${Logo});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;
